import { connect } from "react-redux";
import { CongNoThanhLy } from "components/CongNoThanhLy";
import { getListCongNoThanhLy } from "actions/CongNoThanhLy/index";

const mapStateToProps = (state) => ({
  CongNoThanhLy: state.CongNoThanhLy,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListCongNoThanhLy: (dataSearch) =>
    dispatch(getListCongNoThanhLy(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CongNoThanhLy);
